module.exports = {"310108001":"天目西路街道","310108006":"北站街道","310108007":"宝山路街道","310108012":"共和新路街道","310108013":"大宁路街道","310108014":"彭浦新村街道","310108015":"临汾路街道","310108016":"芷江西路街道","310108101":"彭浦镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/310108.json
// module id = 814
// module chunks = 0